// extracted by mini-css-extract-plugin
module.exports = {"page_header":"_5LEjGh0h"};